module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Bold.woff?45e58f4054a3ad886e4582e1d43056fe";